<template>
  <div class="element-input element-calendar" :class="{ empty: !value }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <i class="material-icons">expand_more</i>
      <datepicker
        :language="ko"
        :disabled-dates="disabledDates"
        :value="date"
        :format="'yyyy. MM. dd'"
        :input-class="'cal-input'"
        :wrapper-class="'cal-wrap'"
        :calendar-class="'cal'"
        @selected="selectDate"
      ></datepicker>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>

import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale'

export default {
  props: [ "value", "label", "error", "items", "disabled", "placeholder", 'isWeekend', 'isBirth'],
  data() {
    return {
      ko: ko,
      date: new Date(),
      today: new Date(),
      disabledDates: {
        to: this.today,
        days: [6, 0],
        // customPredictor: this.customPredictor
      }
    }
  },
  created() {
    this.today.setDate(this.today.getDate() - 1);

    this.date = !this.isDateValid(this.value) ? this.$moment(new Date()).format('YYYY-MM-DD') : this.value;

    if (!this.isDateValid(this.value)) {
      const datetime = this.getDefaultConsultTime();
      this.date = datetime.date.replace('.', '-');
    }

    if(this.$moment(this.value).day() == 0){ // 일요일인 경우 
      this.date = this.$moment(this.value).add(1, 'days').format(); // +1
    }else if(this.$moment(this.value).day() == 6){ // 토요일인 경우
      this.date = this.$moment(this.value).add(2, 'days').format(); // +2
    }

    this.selectDate(this.date)

    if (!this.isBirth) {
      this.disabledDates.to = this.today;
    } else {
      this.disabledDates = { days: [] };
    }

    if (this.isWeekend) {
      this.disabledDates = { to: this.today }
    }

    if (this.$moment(this.value).month() + 1 === 2) {
      if (this.$moment(this.value).date() > 9 && this.$moment(this.value).date() < 13) {
        this.date = new Date('2024-02-13 09:00:00');
        this.disabledDates.to = new Date('2024-02-13 09:00:00');
      }
    }
  },
  components: {
    Datepicker
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectDate( date ) {
      this.$emit("input", this.$moment(date).format('YYYY-MM-DD'));
    },
    customPredictor(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();

      if (month === 9 && (day === 9 || day === 12)) {
        return true;
      }
    },
    isDateValid(dateStr) {
      return !isNaN(new Date(dateStr));
    },
    getConsultDate(date) {
      return this.$moment(date).add(1, 'days').format('YYYY-MM-DD');
    },
    getDefaultConsultTime() {
      const times = this.$moment().format('HH:mm').split(':');
      let hour = times[0] * 1;
      let min = times[1] * 1;
      let date = this.$moment().format('YYYY-MM-DD');

      if (min > 40 && min < 60) {
        hour = hour + 1;
        min = '00';
      }
      
      if (min > 0 && min < 20) {
        min = '20';
      }

      if (min > 20 && min < 40) {
        min = '40';
      }
      
      if (hour > 18) {
        hour = '09';
        min = '00';
        date = this.getConsultDate(date);
      }

      if (hour === 18 && min !== '00') {
        date = this.getConsultDate(date);
        hour = '09';
        min = '00';
      }

      if (hour < 10) {
        if (hour < 9) {
          min = '00';
        }

        hour = '09';
      }

      return {
        time: hour + ':' + min,
        date
      }
    }
  }
}
</script>
